export default __webpack_public_path__ + "static/media/PITMLogo.568fa32e.png";